import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Col, Grid, Row, Table } from 'react-bootstrap';

import { FormattingUtils } from '../../../utils';
import { IContractTermDisplay } from '../../../interfaces';
// The row is presentational and knows nothing about liens, so the loan terms reuse it rather than
// re-deriving the "First 6 months" / "Uncapped" labelling.
import TermsTableRow from '../../page-case/TermsTableRow';
import { describeRateBand, isRateOutOfBand, IRateBand, NO_RATE_BAND } from './terms';

const { formatDuration } = FormattingUtils;

interface IProps {
  isLocked: boolean;
  minimumDuration: null | string;
  onChange: (idx: number, value: string) => void;
  // Only the modal that can edit the rates passes one; a read-only table has no band to hold to.
  rateBand?: IRateBand;
  terms: IContractTermDisplay[];
}

@observer
class LoanTermsTable extends Component<IProps> {
  public render () {
    const { isLocked, minimumDuration, onChange, rateBand = NO_RATE_BAND, terms } = this.props
      , minimumText = minimumDuration && `${formatDuration(minimumDuration)} Minimum`
      // Nothing to say while the template is locked: the rates are shown rather than retyped
      , rateBandText = isLocked ? null : describeRateBand(rateBand)
      ;

    if (!terms.length) { return null; }

    return (
      <Grid className='table-terms' fluid>
        <Row>
          {minimumText
            ? (
              <div>
                <Col xs={6}><h3>Contract Terms</h3></Col>
                <Col xs={6}><h3 className='pull-right'>{minimumText}</h3></Col>
              </div>)
            : <Col xs={12}><h3>Contract Terms</h3></Col>
          }
        </Row>
        {rateBandText && (
          <Row>
            <Col xs={12}><p className='text-muted'>{rateBandText}</p></Col>
          </Row>
        )}
        <Row>
          <Col xs={12}>
            <Table className='contract-terms fix-layout' condensed>
              <thead>
                <tr>
                  <th className='col-sm-3'>Duration</th>
                  <th className='col-sm-6 col-interest-rate'>Rate Of Return</th>
                  <th className='col-sm-3 text-right'>Bucket Length</th>
                </tr>
              </thead>
              <tbody>
                {terms.map((term, idx) => (
                  <TermsTableRow
                    id={idx}
                    isInvalid={!isLocked && isRateOutOfBand(term.interest_rate, rateBand)}
                    key={idx}
                    length={terms.length}
                    locked={isLocked}
                    max={rateBand.maximum}
                    min={rateBand.minimum}
                    onChange={onChange}
                    term={term}
                  />
                ))}
              </tbody>
            </Table>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default LoanTermsTable;
